<script setup>
import { ref } from 'vue';
const props = defineProps({
    modelValue: {
        type: String,
        default: '#000000'
    }
});

const value = ref(props.modelValue || '#000000');
</script>
<template>
    <label tabindex="2" class="flex items-center justify-between gap-3 shadow-sm hover:shadow  whitespace-nowrap ring-1 focus:ring-[2px] focus:ring-indigo-400 ring-gray-200 rounded hover:bg-white transition h-10 cursor-pointer bg-gray-50 px-5" v-bind="$attrs">
        <div class="w-5 h-5 rounded-full shadow-sm" :style="{background: value}"></div>
        <div><slot/></div>
        <input type="color" v-model="value" class="w-0 h-0 opacity-0" @input="$emit('update:modelValue', value)">
    </label>
</template>